import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useSaleCalendar } from '../SaleCalendarContext';
import { getDateRange } from '../../../../services/functions';
import BlockModal from '../modals/BlockModal';

export const PeriodContextMenu = () => {
  const { contextMenu, closeContextMenu, setBlockedResourceDates } = useSaleCalendar();
  const [openBlockModal, setOpenBlockModal] = React.useState(false);

  const handleClose = () => {
    closeContextMenu();
  };
  const blockDateForResource = (unlock = false, reason = '', days = 'all') => {
    const dateRange = getDateRange(contextMenu.start, contextMenu.end);
    const eventObjects = [];

    const dayMap = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6
    };

    dateRange.forEach(d => {
      const jsDay = new Date(d).getDay(); // 0–6
      const includeDay =
        days === 'all' ||
        (Array.isArray(days) && days.some(day => dayMap[day] === jsDay));

      if (includeDay) {
        eventObjects.push({
          start: d,
          end: d,
          resourceId: contextMenu.resourceId,
          display: 'background',
          color: 'rgba(101, 67, 33, 0.5)',
          id: d + d + contextMenu.resourceId,
          title: reason
        });
      }
    });

    setBlockedResourceDates(prev => {
      if (unlock) {
        const eventIds = eventObjects.map(eo => eo.id);

        return [...prev.filter(p => !eventIds.includes(p.id))];
      }

      const prevIds = prev.map(p => p.id);
      const filteredEventObjects = eventObjects.filter(eo => !prevIds.includes(eo.id));

      return [...prev, ...filteredEventObjects];
    });

    handleClose();
  };


  return (
    <>
      <Menu
        open={contextMenu?.visible && Boolean(contextMenu.x) && Boolean(contextMenu.y)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu?.y && contextMenu?.x
            ? { top: contextMenu.y, left: contextMenu.x }
            : undefined
        }
        disableAutoFocusItem
      >
        <MenuItem onMouseDown={() => setOpenBlockModal(true)}>
        Zablokuj dni dla wybranego terminu...
        </MenuItem>
        <MenuItem onMouseDown={() => blockDateForResource(true)}>
        Odblokuj dni dla wybranego terminu
        </MenuItem>
      </Menu>
      <BlockModal
        open={openBlockModal}
        blockFunction={blockDateForResource}
        handleClose={() => setOpenBlockModal(false)}
        showDays={true}
      />
    </>
  );
};
